import { render, staticRenderFns } from "./releaseDynamics.vue?vue&type=template&id=03d82da7&scoped=true"
import script from "./releaseDynamics.vue?vue&type=script&lang=js"
export * from "./releaseDynamics.vue?vue&type=script&lang=js"
import style0 from "./releaseDynamics.vue?vue&type=style&index=0&id=03d82da7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d82da7",
  null
  
)

export default component.exports